const ControlVideos = document.querySelectorAll('.video-with-control video');

if (ControlVideos) {
    ControlVideos.forEach(video => {
        const playButton = video.parentElement.querySelector('.video-controls');
        const TimeDuration = video.parentElement.querySelector('.video-duration-time');
        const videoText = video.parentElement.querySelector('.video-text-top-left');
        
        video.controls = false;
        let lastClickTime = 0;
        const CLICK_DELAY = 200;
        
        video.addEventListener('click', async function(e) {
            if (e.target !== this) return;
            
            const currentTime = Date.now();
            if (currentTime - lastClickTime < CLICK_DELAY) return;
            lastClickTime = currentTime;
            
            try {
                if (this.paused) {
                    await this.play();
                    this.controls = true;
                    if (playButton) {
                        playButton.classList.add("hidden");
                    }
                    if (TimeDuration) {
                        TimeDuration.classList.add("hidden");
                    }
                    if (videoText) {
                        videoText.classList.add("hidden");
                    }
                } else {
                    this.pause();
                    this.controls = false;
                   
                }
            } catch (error) {
                this.controls = false;
                if (playButton) {
                  playButton.classList.add("hidden");
                }
                if (TimeDuration) {
                    TimeDuration.classList.add("hidden");
                }
                if (videoText) {
                    videoText.classList.add("hidden");
                }
            }
        });

        video.addEventListener('ended', function() {
            this.controls = false;
            if (playButton) {
              playButton.classList.add("hidden");
            }
            if (TimeDuration) {
                TimeDuration.classList.add("hidden");
            }
            if (videoText) {
                videoText.classList.add("hidden");
            }
        });
        if (playButton) {
            playButton.addEventListener('click', async () => {
                try {
                    if (video.paused) {
                        await video.play();
                        video.controls = true;
                    }
                } catch (error) {
                    video.controls = false;
                    playButton.classList.add("hidden");
                    TimeDuration.classList.add("hidden");
                }
                if (videoText) {
                    videoText.classList.add("hidden");
                }
            });
        }
    });
}